import Animation from "react-native-web-lottie";

export default Animation;
